export default __webpack_public_path__ + "static/media/champselect-logo-with-text.01657963.svg";